import * as Sentry from '@sentry/react';

import {ENVIRONMENT, SENTRY_DSN, IS_DEV_MODE} from '~/modules/config';

export const initLogging = () => {
  if (!IS_DEV_MODE) {
    Sentry.init({
      dsn: SENTRY_DSN,
      environment: ENVIRONMENT,
      tracesSampleRate: 1.0,
    });
  }
};

export const generateCrash = () => {
  throw new Error('TEST ERROR');
};
